import React, { useState, useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCollect } from 'hooks';

import Update from 'containers/Shared/Courses/Profile/Studentz/Unassigned/Update';

const Unassigned = ({ refresh }) => {
	// Store current object's id
	const { id } = useParams();

	// Store  modal state
	const [modal, setModal] = useState(false);

	// Handle expand toggle
	const onModal = () => setModal(m => !m);

	// Store request parameters
	const parameters = useMemo(() => ({
		condition: 'students:unassigned'
	}), []);

	// Store requested students
	const [[students], collect] = useCollect(`courses/${id}`, parameters);

	// Collect students on mount
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// Do not show unless there are unassigned students
	if (!students?.length) return null;

	return (
		<>
			<div className="mt-4 py-4 px-4 bg-rose-500 rounded-lg flex items-center animate-fade-in">
				<div className="text-base text-white flex-1">
				Atrasti <span className="font-semibold text-lg">{students?.length}</span> studenti, kuriem dotajā modulī nav piesaistīts pārbaudes darbs!
				</div>

				<div className="h-8 px-3 leading-8 bg-rose-400 text-white rounded-lg cursor-pointer hover:bg-rose-600 transition-colors" onClick={onModal}>
				Pievienot
				</div>
			</div>
			
			<Update modal={modal} onModal={onModal} refresh={refresh} />
		</>
	);
};

export default Unassigned;